import { useMemo } from 'react';

export interface UseImageDimensionsProps {
  displayWidth: number;
  displayHeight: number;
  contenerWidth: number;
  contenerHeight: number;
  rotateAngle: number;
  displayMargin: number;
}

export const useImageCssRotation = ({
  displayWidth,
  displayHeight,
  rotateAngle,
  displayMargin,
  contenerWidth,
  contenerHeight,
}: UseImageDimensionsProps) => {
  const isDisplayAngleHorizontal = Math.abs((rotateAngle - 90) % 180) === 0;

  const rotatedImageLeft = useMemo(() => {
    switch (rotateAngle) {
      case 90:
      case 180:
        return displayWidth;

      default:
        return 0;
    }
  }, [rotateAngle, displayWidth]);

  const rotatedImageTop = useMemo(() => {
    switch (rotateAngle) {
      case 180:
      case 270:
        return displayHeight;

      default:
        return 0;
    }
  }, [rotateAngle, displayHeight]);

  const rotatedImageWidth = isDisplayAngleHorizontal ? displayHeight : displayWidth;
  const rotatedImageHeight = isDisplayAngleHorizontal ? displayWidth : displayHeight;

  const imageWrapperLeft = Math.max(displayMargin, displayMargin + contenerWidth / 2 - displayWidth / 2);
  const imageWrapperTop = Math.max(displayMargin, displayMargin + contenerHeight / 2 - displayHeight / 2);
  const imageWrapperWidth = displayWidth;
  const imageWrapperHeight = displayHeight;

  return {
    rotatedImageDimensions: {
      left: rotatedImageLeft,
      top: rotatedImageTop,
      width: rotatedImageWidth,
      height: rotatedImageHeight,
    },
    imageWrapperDimensions: {
      left: imageWrapperLeft,
      top: imageWrapperTop,
      width: imageWrapperWidth,
      height: imageWrapperHeight,
    },
  };
};
